import React, { FC, useRef } from 'react';
import { commonUtils } from 'redux/_common';

interface ISearchBarProps {
    searchBy: string;
    setSearchBy: (searchBy: string) => void;
    setBooksUsingSearchBy: (searchBy: string) => void;
}

const SearchBar: FC<ISearchBarProps> = (props) => {
    const { searchBy, setSearchBy } = props;
    const debouncedSave = useRef(commonUtils.debounce(
      props.setBooksUsingSearchBy,
      1000
    ));
    return (
        <div className="flex items-center relative">
            <input
                placeholder="Search"
                className="bg-app_background w-full text-xs font-medium leading-4 tracking-wide border border-gray-400 rounded-[4px] flex-1 px-2 py-2"
                type="text"
                value={searchBy}
                onChange={(e) => {
                    setSearchBy(e.target.value);

                    // search after 1 second when user stopped typing
                    debouncedSave.current(e.target.value);
                }}
            />
            <div className="absolute right-2 flex items-center justify-center">
                <span className="bp3-icon bp3-icon-search text-[#787885]" />
            </div>
        </div>
    );
};

export default SearchBar;
